const FeridaVascular = () => {
  return <></>;
};

export default FeridaVascular;
